import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/** Style callbacks typed so they can be combined in `sx={[a, b]}` arrays. */
export type StatRowStyle = (theme: Theme) => SystemStyleObject<Theme>;

export const STAT_ROW_BREAKPOINT = '@container (min-width: 600px)';

const MAIN_COLUMN_WIDTH = '64%';

export const statRowSx: StatRowStyle = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  [STAT_ROW_BREAKPOINT]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: backrs.spacing['spacing-6xl'],
  },
});

export const statRowMainSx: StatRowStyle = ({ backrs }) => ({
  minWidth: 0,
  [STAT_ROW_BREAKPOINT]: {
    flex: `0 0 calc(${MAIN_COLUMN_WIDTH} - ${backrs.spacing['spacing-3xl']})`,
  },
});

export const statRowStatsSx: StatRowStyle = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  minWidth: 0,
  [STAT_ROW_BREAKPOINT]: {
    flex: '1 1 0',
  },
});
